import sourceMetricSchemaUIStore from './sourceMetricSchemaUIStore.js';
import sourceMetricSchemaDataStore from './sourceMetricSchemaDataStore.js';

export default {
  modules: {
    ui: sourceMetricSchemaUIStore,
    data: sourceMetricSchemaDataStore,
  },
};
